var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.689,
    height: 52.059,
    viewBox: "0 0 57.689 52.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3063",
    "data-name": "Rectangle 3063",
    width: 57.689,
    height: 52.059,
    fill: "currentcolor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(0 0.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3059",
    "data-name": "Rectangle 3059",
    width: 10.597,
    height: 10.246,
    transform: "translate(0 41.808)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3060",
    "data-name": "Rectangle 3060",
    width: 10.597,
    height: 27.118,
    transform: "translate(15.697 24.935)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3061",
    "data-name": "Rectangle 3061",
    width: 10.597,
    height: 20.297,
    transform: "translate(31.394 31.757)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3062",
    "data-name": "Rectangle 3062",
    width: 10.597,
    height: 38.468,
    transform: "translate(47.091 13.586)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(0 -0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M108.018,0a3.579,3.579,0,0,0-2.984,5.543L93.833,18.5a3.558,3.558,0,0,0-4.256.954l-9.418-4.186a3.571,3.571,0,1,0-6.551,1.41L62.979,28.58a3.542,3.542,0,0,0-1.566-.363,3.582,3.582,0,1,0,3.016,1.667l10.629-11.9a3.559,3.559,0,0,0,4.31-.929l9.418,4.186a3.571,3.571,0,1,0,7.106.5,3.565,3.565,0,0,0-.587-1.963l11.2-12.966a3.542,3.542,0,0,0,1.512.338,3.58,3.58,0,0,0,0-7.16M61.413,33.424A1.627,1.627,0,1,1,63.036,31.8a1.627,1.627,0,0,1-1.623,1.627M76.624,16.4a1.627,1.627,0,1,1,1.623-1.627A1.627,1.627,0,0,1,76.624,16.4m15.7,6.977a1.627,1.627,0,1,1,1.623-1.627,1.627,1.627,0,0,1-1.623,1.627M108.018,5.2a1.627,1.627,0,1,1,1.623-1.627A1.627,1.627,0,0,1,108.018,5.2",
    transform: "translate(-55.628 0.005)",
    fill: "currentcolor"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.7a4b0f65.svg";
export { ForwardRef as ReactComponent };